/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedResponse_TaskBudgetResponse_ } from '../models/PaginatedResponse_TaskBudgetResponse_';
import type { TaskBudgetCreateRequest } from '../models/TaskBudgetCreateRequest';
import type { TaskBudgetCreateResponse } from '../models/TaskBudgetCreateResponse';
import type { TaskBudgetResponse } from '../models/TaskBudgetResponse';
import type { TaskBudgetUpdateRequest } from '../models/TaskBudgetUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TaskBudgetService {
    /**
     * Create Task Budget
     * 세부실행과제 예산 생성 (예산 항목 포함 가능)
     *
     * 새로운 세부실행과제 예산을 생성합니다.
     * 선택적으로 예산 항목들도 함께 생성할 수 있습니다.
     *
     * Args:
     * data: 예산 생성 요청 데이터
     * - task_id: 세부실행과제 ID
     * - result_description: 결과 설명
     * - items: 예산 항목 목록 (선택사항)
     *
     * Returns:
     * 201: 생성된 예산 및 항목 정보
     * 400: 잘못된 요청 데이터
     * 401: 인증 실패
     * 409: 중복 데이터
     * 500: 서버 내부 오류
     * @returns TaskBudgetCreateResponse Created
     * @throws ApiError
     */
    public static appsTaskViewsCreateTaskBudget({
        requestBody,
    }: {
        requestBody: TaskBudgetCreateRequest,
    }): CancelablePromise<TaskBudgetCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/task/budget',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Task Budgets
     * 세부실행과제 예산 목록 조회
     *
     * 세부실행과제 예산을 페이징하여 조회합니다.
     *
     * Args:
     * workspace_id: 워크스페이스 ID (필수)
     * task_id: 세부실행과제 ID로 필터링 (선택사항)
     * page: 페이지 번호 (기본값: 1)
     * per_page: 페이지당 항목 수 (기본값: 50)
     * start_date: 시작일 (YYYY-MM-DD 형식, end_date와 함께 사용)
     * end_date: 종료일 (YYYY-MM-DD 형식, start_date와 함께 사용)
     * department_id: 부서 ID로 필터링 (선택사항)
     * business_id: 사업 ID로 필터링 (선택사항)
     * assignee_id: 담당자 ID로 필터링 (선택사항)
     * sub_assignee_id: 부담당자 ID로 필터링 (선택사항)
     * manager_id: 관리자 ID로 필터링 (선택사항)
     * reviewer_id: 검토자 ID로 필터링 (선택사항)
     * stakeholder_id: 이해관계자 ID (OR 조건으로 모든 역할 검색, 선택사항)
     * status: 예산 상태 (completed | incomplete, 선택사항)
     * @returns PaginatedResponse_TaskBudgetResponse_ OK
     * @throws ApiError
     */
    public static appsTaskViewsListTaskBudgets({
        workspaceId,
        q,
        taskId,
        page = 1,
        perPage = 100,
        startDate,
        endDate,
        departmentId,
        businessId,
        assigneeId,
        subAssigneeId,
        managerId,
        reviewerId,
        stakeholderId,
        status,
    }: {
        workspaceId: string,
        q?: string,
        taskId?: string,
        page?: number,
        perPage?: number,
        startDate?: string,
        endDate?: string,
        departmentId?: string,
        businessId?: string,
        assigneeId?: string,
        subAssigneeId?: string,
        managerId?: string,
        reviewerId?: string,
        stakeholderId?: string,
        status?: string,
    }): CancelablePromise<PaginatedResponse_TaskBudgetResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/budget',
            query: {
                'workspace_id': workspaceId,
                'q': q,
                'task_id': taskId,
                'page': page,
                'per_page': perPage,
                'start_date': startDate,
                'end_date': endDate,
                'department_id': departmentId,
                'business_id': businessId,
                'assignee_id': assigneeId,
                'sub_assignee_id': subAssigneeId,
                'manager_id': managerId,
                'reviewer_id': reviewerId,
                'stakeholder_id': stakeholderId,
                'status': status,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Task Budget
     * 세부실행과제 예산 조회
     *
     * ID로 특정 예산을 조회합니다.
     * @returns TaskBudgetResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetTaskBudget({
        budgetId,
    }: {
        budgetId: string,
    }): CancelablePromise<TaskBudgetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/budget/{budget_id}',
            path: {
                'budget_id': budgetId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Task Budget
     * 세부실행과제 예산 수정
     *
     * 특정 예산의 정보를 수정합니다.
     * @returns TaskBudgetResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsUpdateTaskBudget({
        budgetId,
        requestBody,
    }: {
        budgetId: string,
        requestBody: TaskBudgetUpdateRequest,
    }): CancelablePromise<TaskBudgetResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/task/budget/{budget_id}',
            path: {
                'budget_id': budgetId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Task Budget
     * 세부실행과제 예산 삭제
     *
     * 특정 예산을 삭제합니다. (소프트 삭제)
     * @returns void
     * @throws ApiError
     */
    public static appsTaskViewsDeleteTaskBudget({
        budgetId,
    }: {
        budgetId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/task/budget/{budget_id}',
            path: {
                'budget_id': budgetId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
